import { createContext } from 'react';
import { StaffMember } from '@/types/api/staffMember';

export type StaffMemberByPersonContext = {
  isLoading: boolean;
  staffMember?: StaffMember;
};

const context = createContext<StaffMemberByPersonContext>({
  isLoading: false,
});

export default context;
